import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { BookingServiceListComponent } from './booking-service-list.component';
import {SharedModule} from '../../shared.module';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';

@NgModule({
  declarations: [
    BookingServiceListComponent
  ],
  imports: [
    BrowserModule,
    SharedModule,
    MatCardModule,
    MatListModule,
    MatIconModule,
    MatButtonModule
  ],
  exports: [
    BookingServiceListComponent
  ],
  entryComponents: [],
  providers: []
})
export class BookingServiceListModule {}
